import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DesignAngularKitModule, IconName } from 'design-angular-kit';
import { Note } from '../../../../models/note.dto';
import { NoteService } from '../../../../services/note.service';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-notification-card',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule],
  templateUrl: './notification-card.component.html',
  styleUrl: './notification-card.component.scss'
})
export class NotificationCardComponent {
  @Input() note!: Note;
  @Output() notificationRead= new EventEmitter<boolean>();

  constructor(private noteService: NoteService, public authService: AuthService) { }

  setNotificationRead() {
    const request = {
      operatorCode: this.authService.userInfo.username,
      noteIds: [this.note.id]
    }

    this.noteService.setRead(request).subscribe(response => {
      this.notificationRead.emit(true);
    })
  }
}
